import React from 'react';

const SecondaryTitle = (props) => {
    return (
        <h3
            onClick={() => props.onClick()}
            className={'secondary-title'}
            style={!!props && !!props.style ? props.style : {}}
        >{props.children}</h3>
    );
}

export default SecondaryTitle;
